import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "m17.87 12-2.398 1.128 1.277 2.323-2.604-.499-.33 2.63-1.814-1.934-1.813 1.935-.33-2.63-2.604.497 1.277-2.322L6.133 12l2.398-1.128L7.254 8.55l2.604.498.33-2.63L12 8.351l1.814-1.935.33 2.631 2.604-.498-1.277 2.322z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M12 15.652a3.652 3.652 0 1 0 0-7.305 3.652 3.652 0 0 0 0 7.305"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M10.175 12a3 3 0 0 0-.26.014c.002.505.185.968.488 1.328a3.7 3.7 0 0 1 .705-1.168 2.6 2.6 0 0 0-.933-.173M11.3 13.967a2.08 2.08 0 0 0 1.405 0 2.6 2.6 0 0 0-.702-1.218 2.6 2.6 0 0 0-.702 1.218M13.81 10.957a2.086 2.086 0 0 0-3.615 0 3.63 3.63 0 0 1 1.808.491 3.6 3.6 0 0 1 1.807-.49M12.895 12.174c.303.339.544.734.705 1.168.302-.36.485-.822.489-1.328a2.6 2.6 0 0 0-1.194.16"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }